import { render, staticRenderFns } from "./ReferralClaim.vue?vue&type=template&id=abdf6062"
import script from "./ReferralClaim.vue?vue&type=script&lang=js"
export * from "./ReferralClaim.vue?vue&type=script&lang=js"
import style0 from "./ReferralClaim.vue?vue&type=style&index=0&id=abdf6062&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports